import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { ScriptsModule } from '../../modules/scripts.module';
import { CurrencyService } from '../../services/currency.service';
import { Cotizacion } from '../../obj/cotizacion';
import { ResCotizacion } from '../../obj/resCotizacion';
import { Compra } from '../../obj/compra';
import { ActivatedRoute, Router } from '@angular/router';
import { ComprarService } from '../../services/general/comprar.service';
import { LoggerService } from '../../services/extra/logger.service';

import { Md5 } from 'ts-md5/dist/md5';

declare var $: any;

@Component({
  selector: 'app-comprar',
  templateUrl: './comprar.component.html',
  styleUrls: ['./comprar.component.css'],
  providers: [ComprarService, LoggerService]
})
export class ComprarComponent implements OnInit {
  public modelPoliza;
  public modelCotizacion;
  public model;
  public diasContraEntrega;
  public resultadoCompra;
  public resultadoLC;
  //variables popup
  public pedido;
  public mensaje;
  public titulo;

  public tipoMoneda = 'USD';
  public valorMoneda = 0;

  constructor(public _currencyService: CurrencyService, private route: ActivatedRoute, private router: Router, private co: ComprarService, private logger: LoggerService) { }

  ngOnInit() {
    let scripts = new ScriptsModule;
    // scripts.loadScript('assets/js/scripts/solicitar.js');
    var cotizacion = localStorage.getItem('currentCotizacion');
    var poliza = localStorage.getItem('currentPoliza');
    var compra = localStorage.getItem('currentCompra');

    //ACA SE DEBE CONTROLAR LOS EMAILS ENVIADOS
    if (compra == null)
      this.model = new Compra();
    else
      this.model = JSON.parse(compra);

    this.model.medioPago = "";
    if (cotizacion == null)
      this.router.navigate(['/comparar']);
    else{
      this.modelCotizacion = JSON.parse(cotizacion);
    }

    if (poliza == null)
      this.router.navigate(['/comparar']);
    else
      this.modelPoliza = JSON.parse(poliza);
      this.tipoMoneda = this._currencyService.getCurrency();
      if(this._currencyService.getValor() == 0) {
        let valor = Math.round(this.conversionMonedas(this._currencyService.getCurrency()));
        this._currencyService.setValor(valor);
        this.valorMoneda = valor;
      }
      else {
        this.valorMoneda = Math.round(this._currencyService.getValor());
      }

    this.co.getDias().then(resc => {
      this.diasContraEntrega = resc;
    });

    this.logger.log(JSON.stringify(cotizacion));
  }


  ngAfterViewInit() {

    var d = new Date();
    this.model.referencia = d.getTime();
    //datos pagos online
    var llave = "131bef7b598";
    this.model.usuarioId = "73585";
    this.model.descripcion = "SEGURO MEDICO - " + this.model.facNombre;
    //this.model.valorCop = this.modelPoliza.precioCop;
    this.model.moneda = this.tipoMoneda;
    this.model.valor = this.valorMoneda + (this.modelPoliza.totalUpgrade ? this.modelPoliza.totalUpgrade: 0);
    this.model.iva = 0;
    this.model.baseDevolucionIva = 0;
    this.model.urlConfirmacion = "https://embeddedapi.segurosmedicosinternacionales.com.co/confirmarPago";
    this.model.urlRespuesta = "https://www.segurosmedicosinternacionales.com.co";
    this.model.firma = Md5.hashStr(llave + "~" + this.model.usuarioId + "~" + this.model.referencia + "~" + this.model.valor + "~" + this.model.moneda);
    this.model.emailComprador = "";
    this.model.prueba = "0";

  }

  onSubmit() {
    //GENERAMOS CODIGO REFERENCIA EN CADA CLICK
    if (this.model.medioPago == "") {
      this.pedido = "";
      this.titulo = "Problemas con el pedido";
      this.mensaje = "Seleccione un metodo de pago!!";
      $('#modalComprar').modal('show');
      return;
    }
    let upgrade = [];
    for (const i of this.model.pasajeros) {
      console.log(i.upgrade)
      if (i.upgrade) {
        upgrade.push(
          ...i.upgrade.map(a => { return {
            precioUnitario: a.caracteristicasSelect.valor,
            idProducto: a.caracteristicasSelect.id, descuento: 0,
            cantidadPasajeros: this.model.pasajeros.length,
            documentoPasajero: i.documento
          }})
        );
      }
    }
    let medioPago;
    this.model.upgrade = upgrade;
    if (parseInt(this.model.medioPago) >= 4) {
      if (parseInt(this.model.medioPago) == 15) {
        medioPago = "5";
      } else {
        medioPago = "4";
      }
    } else {
      if (parseInt(this.model.medioPago) != 1) {
        medioPago = "1";
      }
    }
    this.model.medioPago = medioPago == "5" ? "2": medioPago
    var compra = JSON.stringify({...this.model, idTipoViaje: this.modelCotizacion.tipo, origen: this.modelCotizacion.origen});
    this.logger.log(JSON.stringify(compra)); //log
    $('#divCargador').show();

    this.co.addCompra(compra).then(resc => {
      this.resultadoCompra = resc;
      if (this.resultadoCompra.resultado) {

        // this.co.apiParques(compra).then(parque => {
        //   console.log(parque)
        // })

        if (medioPago == 1 || medioPago == 2) {//TARJETA - PSE
          this.model.descripcion = "SEGURO MEDICO - " + this.model.facNombre;
          this.model.emailComprador = this.model.facEmail;
          console.log(this.model.descripcion);
          setTimeout(() => {
            (<HTMLFormElement>document.getElementById('frmPagosOnline')).submit();
          }, 1000);

          // localStorage.removeItem('currentCotizacion');
          // localStorage.removeItem('currentPoliza');
          // localStorage.removeItem('currentCompra');
        }
        else {//PAGO CONTRAENTREGA - CONSIGNACION
          if (medioPago == 5) {
            this.co.orderPaypal(Math.round(this.conversionMonedas('USD')), this.model.referencia).then((resc: any) => {
              location.href = resc.links[1].href;
            });
          } else {
            this.pedido = this.model.referencia;
            this.titulo = "Gracias por tomar su póliza de viaje con SEGUROS MEDICOS  INTERNACIONALES";
            this.mensaje = "Pronto estaremos en contacto.";
            $('#modalComprar').modal('show');
            localStorage.removeItem('currentCotizacion');
            localStorage.removeItem('currentPoliza');
            localStorage.removeItem('currentCompra');
          }

        }
      }
      else {
        this.pedido = "";
        this.titulo = "Problemas con el pedido";
        this.mensaje = "Por favor valida los datos tu pedido!!";
        $('#modalComprar').modal('show');
      }
      $('#divCargador').hide();
    });
  }

  quitarUpgrade(posicion, upgrade) {
    for (let i = 0; i < this.model.pasajeros.length; i++) {
      this.model.pasajeros[this.model.pasajeros.findIndex(a => a.numero == posicion)].upgrade.find(a => a.Id == upgrade.Id)['montoPasajero'+i] = "";
      this.model.pasajeros[this.model.pasajeros.findIndex(a => a.numero == posicion)].upgrade.find(a => a.Id == upgrade.Id)['monto'] = "";
    }
    this.model.pasajeros[this.model.pasajeros.findIndex(a => a.numero == posicion)].upgrade.splice(this.model.pasajeros[this.model.pasajeros.findIndex(a => a.numero == posicion)].upgrade.findIndex(a => a.Id == upgrade.Id), 1)
    // this.precioUpgrade();
  }


  datosPasajero1($event) {

    if ($event.target.checked) {
      this.model.facDocumento = this.model.pasajeros[0].documento;
      this.model.facNombre = this.model.pasajeros[0].nombre +' '+ this.model.pasajeros[0].apellido;
      this.model.facDireccion = this.model.pasajeros[0].direccion;
      this.model.facTelefono = this.model.pasajeros[0].telefono;
      this.model.facCiudad = "";
      this.model.facEmail = this.model.pasajeros[0].email;

      this.logger.log(JSON.stringify(this.model));
    } else {
      this.model.facDocumento = "";
      this.model.facNombre = "";
      this.model.facDireccion = "";
      this.model.facTelefono = "";
      this.model.facCiudad = "";
      this.model.facEmail = "";
    }


  }


  checkedLealCoin(evt) {
    var target = evt.target;
    if (target.checked) {

      this.loadLealCoin();

    }
  }

  conversionMonedas(indice:String) {
    let coleccion = this.modelPoliza.conversionMoneda;
    let item = coleccion.filter(x => x.id == indice)[0];
    this._currencyService.setValor(item.valor);
    return item.valor;
  }

  descargarQR() {
    const fileName = 'codigoQR2.jpg'; // Nombre del archivo en la carpeta assets
    const filePath = `assets/images/${fileName}`; // Ruta relativa dentro de la carpeta assets

    // Crear un enlace (a) programáticamente
    const link = document.createElement('a');
    link.href = filePath;
    link.download = fileName; // Establecer el nombre con el que se descargará

    // Agregar el enlace al DOM, hacer clic en él y luego removerlo
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  loadLealCoin() {

    $('#divCargador').show();

     debugger;

     this.co.consultarUID(this.model.facDocumento).then(resc => {

       this.resultadoLC = resc;


       if (this.resultadoLC.resultado) {

          debugger;


       }
       else {
         this.pedido = "";
         this.titulo = "Problemas obteniendo datos de Leal Coins";
         this.mensaje = "Por favor intenta nuevamente o comunicate con soporte!";
         $('#modalComprar').modal('show');
       }
       $('#divCargador').hide();
     });

  }

  get currentCompra() { return JSON.stringify(this.model); }
}



// WEBPACK FOOTER //
// ./src/app/components/comprar/comprar.component.ts